

import JpCustomer from "../images/jp/customer-20250120.png"


import { UserLogoMapType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {


    jp: JpCustomer,

};
